import React from 'react';
import { Box, Container, Divider, IconButton, Stack, Typography } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ mt: 'auto' }}>
      <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.08)' }} />
      <Box
        sx={{
          py: 3,
          backgroundColor: 'rgba(15, 23, 42, 0.6)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent="space-between"
          >
            <Typography variant="body2" color="text.secondary">
              © {year} Alexandre Mami. All rights reserved.
            </Typography>

            <Stack direction="row" spacing={1}>
              <IconButton
                aria-label="Email"
                href="mailto:contact@mamialexandre.fr"
                sx={{ color: 'text.secondary', '&:hover': { color: '#FFC107' } }}
              >
                <EmailIcon />
              </IconButton>
              <IconButton
                aria-label="LinkedIn"
                href="https://www.linkedin.com/in/alexandre-mami"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'text.secondary', '&:hover': { color: '#FFC107' } }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                aria-label="GitHub"
                href="https://github.com/lalik77"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'text.secondary', '&:hover': { color: '#FFC107' } }}
              >
                <GitHubIcon />
              </IconButton>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
